import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';
import PRICE_NEGOTIATION_PERMISSIONS_NAMES from './priceNegotiationPermissionsNames';
import { useSelector } from 'react-redux';

const usePriceNegotiationPermissions = (requestedPermissionName) => {
  if (PRICE_NEGOTIATION_PERMISSIONS_NAMES[requestedPermissionName] === undefined) {
    throw new Error(
      `Price negotiation permission with name ${requestedPermissionName} does not exist`
    );
  }
  try {
    const priceNegotiationPermissions =
      useSelector((state) =>
        getSpecificClientConfig(state, constants.PRICE_NEGOTATION_PERMISSIONS)
      ) || {};
    const requestedPermissionValue =
      priceNegotiationPermissions[PRICE_NEGOTIATION_PERMISSIONS_NAMES[requestedPermissionName]];
    return requestedPermissionValue;
  } catch (e) {
    console.error(e);
    return false;
  }
};

export default usePriceNegotiationPermissions;
